module.exports = __webpack_public_path__ + "img/yunnan01.fd0e0b7a.png";